
<template>
  <div class="mail__mail-item sm:px-4 px-2 py-6 relative" :class="{ 'mail__opened-mail': !mail.isOpen }">
    <!-- MAIL ROW 1 : META -->
    <div class="flex w-full">
      <!-- <vs-avatar
        class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white"
        :src="require('@/assets/images/profile-image.png')"
        size="40px"
      ></vs-avatar> -->

      <vs-checkbox
        v-model="isSelectedMail"
        @click.native.stop
        class="vs-checkbox-small mt-2 ml-0 absolute top-0"
        style="left: 8px"
      ></vs-checkbox>

      <div class="flex flex-col justify-center">
        <vs-avatar
          class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white"
          size="40px"
          :color="venue.style.colorBackground"
          :src="venue.logoUrl"
        />
      </div>

      <div class="flex w-full justify-between items-start">
        <div class="mail__details">
          <h5 class="mb-1">
            <span class="font-semibold">
              {{ mail.guestEmailName }}
            </span>
            <span class="text-sm"> to </span>
            <span class="text-sm font-semibold">
              {{ mail.venueName }}
            </span>
          </h5>
          <span v-if="mail.subject">{{ mail.subject }}</span>
          <span v-else>(no subject)</span>

          <div class="mt-2">
            <vs-chip color="primary" class="mr-1">
              <vs-avatar icon="info" class="avatar-icon-lg" /> {{ mail.status | formatWord }}
            </vs-chip>
            <vs-chip v-for="topic in mail.topics" :key="topic.topic" :color="topic.color" class="mr-1">{{
              topic.topic
            }}</vs-chip>
          </div>
        </div>

        <div class="mail-item__meta flex items-center">
          <div class="email__labels hidden sm:flex items-center">
            <div
              class="h-2 w-2 rounded-full mr-2"
              :class="'bg-' + labelColor(label)"
              v-for="(label, index) in mail.labels"
              :key="index"
            ></div>
          </div>
          <div class="flex flex-col items-end">
            <vs-chip color="green" v-if="timeSinceLastMessage == 'Just now'">
              <span class="whitespace-no-wrap">{{ timeSinceLastMessage }}</span>
            </vs-chip>
            <span v-else class="whitespace-no-wrap">{{ timeSinceLastMessage }}</span>

            <span>{{ mail.lastMessageTimestamp | date }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- /MAIL ROW 1 -->

    <!-- MAIL ROW 2 : MSG & ACTIONS -->
    <div class="flex w-full mt-2">
      <div class="flex items-center ml-8"></div>
      <div class="mail__message truncate ml-8 flex-grow">
        <span v-if="lastMessage.didSend"
          ><b>{{ venue.name }}:</b> {{ lastMessage.snippet }}</span
        >
        <span v-else>{{ lastMessage.snippet }}</span>
      </div>

      <div class="flex justify-self-end pl-2">
        <div v-if="mail.assignee" class="text-xs">Assigned to {{ mail.assignee.userDisplayName }}</div>
        <div v-else class="text-xs">Unassigned</div>
      </div>
    </div>
    <!-- /MAIL ROW 2 -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    mail: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isSelectedMail: this.isSelected,
      timeSinceLastMessage: "",
    };
  },
  watch: {
    isSelected(value) {
      this.isSelectedMail = value;
    },
    isSelectedMail(val) {
      val ? this.$emit("addToSelected", this.mail.id) : this.$emit("removeSelected", this.mail.id);
    },
  },
  methods: {
    updateTimeAgo() {
      moment.locale("en", {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "Just now",
          ss: "%ss",
          m: "1m",
          mm: "%dm",
          h: "1h",
          hh: "%dh",
          d: "1d",
          dd: "%dd",
          M: "1M",
          MM: "%dM",
          y: "1Y",
          yy: "%dY",
        },
      });
      this.timeSinceLastMessage = moment(this.lastMessage.timestamp).fromNow(true);
    },
  },
  computed: {
    venue() {
      return this.$store.getters["venues/venue"](this.mail.venueId);
    },
    lastMessage() {
      return this.$store.getters["email/conversationLastMessage"](this.mail.id);
    },
    labelColor() {
      return label => {
        const tags = this.$store.state.email.mailTags;
        return tags.find(tag => {
          return tag.value === label;
        }).color;
      };
    },
  },
  mounted() {
    this.updateTimeAgo();
    setInterval(this.updateTimeAgo, 500);
  },
};
</script>

